import type { BadgeProps } from '@cloudscape-design/components/badge';
import type { HealthSignalKind } from '@etiquetachef/types';

/**
 * Cor de Badge (Cloudscape) por signal kind. Cardinalidade fechada
 * (red/grey) pra não inflar o design system. Sprint 39.
 */
export const SIGNAL_BADGE_COLOR: Record<HealthSignalKind, NonNullable<BadgeProps['color']>> = {
  PRINT_ERROR_RECURRING: 'red',
  SUSPECTED_DATA_RESET: 'red',
  BILLING_INCONSISTENT: 'red',
  ZOMBIE: 'grey',
  PRE_CHURN_RISK: 'red',
  BACKFILL_PENDING: 'grey',
};
